import {COUNTRY_NAMES_EN, COUNTRY_NAMES_HE} from './data/country-names.generated';

export type CountryLocale = 'he' | 'en';

export interface CountryOption {
  value: string;
  label: string;
}

function resolveCountryLocale(locale: string): CountryLocale {
  return locale === 'he' ? 'he' : 'en';
}

function namesForLocale(locale: CountryLocale): Record<string, string> {
  return locale === 'he' ? COUNTRY_NAMES_HE : COUNTRY_NAMES_EN;
}

const countryOptionsCache = new Map<CountryLocale, CountryOption[]>();

// Cached per locale — sibling fields on the same form share one sorted 250-entry array instead of each re-sorting it.
export function getCountryOptions(locale: string): CountryOption[] {
  const resolved = resolveCountryLocale(locale);
  const cached = countryOptionsCache.get(resolved);
  if (cached) return cached;

  const names = namesForLocale(resolved);
  const options = Object.entries(names)
    .map(([value, label]) => ({value, label}))
    .sort((a, b) => a.label.localeCompare(b.label, resolved));
  countryOptionsCache.set(resolved, options);
  return options;
}

// Falls back to the raw value for legacy free-text country data typed before this became a select.
export function getCountryDisplayName(value: string, locale: string): string {
  return namesForLocale(resolveCountryLocale(locale))[value.toUpperCase()] ?? value;
}
